const getLockupRows = (offerData) => {
    const rows = offerData?.publicoAlvoDatasLockup?.rows ?? []

    return rows.map((row) => {
        const origem = row.label

        return {
            label: row.label,
            values: [
                {
                    label: `Data lockup ${origem} para IG`,
                    value: row.values?.ig,
                },
                {
                    label: `Data lockup ${origem} para IP`,
                    value: row.values?.ip,
                },
                {
                    label: `Data lockup ${origem} para IQ`,
                    value: row.values?.iq,
                },
            ],
        }
    })
}

const getOfertaModalSections = (offerData) => [
    {
        type: "split",
        gridTemplateColumns: {
            xxxs: "1fr",
            xs: "1fr",
            sm: "1fr",
            md: "1fr",
            lg: "minmax(0, 9fr) minmax(0, 3fr)",
        },
        columns: [
            {
                title: "SRE CVM",
                md: 9,
                fields: [
                    {
                        label: "Tipo rito",
                        value: offerData?.sreCvm?.tipoRito,
                        xs: 4,
                        sm: 4,
                        md: 2,
                    },
                    {
                        label: "Data requerimento",
                        value: offerData?.sreCvm?.dataRequerimento,
                        xs: 4,
                        sm: 4,
                        md: 2,
                    },
                    {
                        label: "Distribuição link SRE",
                        value: offerData?.sreCvm?.distribuicaoLinkSre,
                        href: offerData?.sreCvm?.distribuicaoLinkSreHref,
                        xs: 4,
                        sm: 4,
                        md: 3,
                    },
                    {
                        label: "Tipo mercado",
                        value: offerData?.sreCvm?.tipoMercado,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Regime distribuição",
                        value: offerData?.sreCvm?.regimeDistribuicao,
                        xs: 6,
                        sm: 6,
                        md: 3,
                    },
                ],
            },
            {
                title: "Data Reserva",
                md: 3,
                fields: [
                    {
                        label: "Início",
                        value: offerData?.dataReserva?.inicio,
                        xs: 6,
                        sm: 6,
                        md: 6,
                    },
                    {
                        label: "Encerramento",
                        value: offerData?.dataReserva?.encerramento,
                        xs: 6,
                        sm: 6,
                        md: 6,
                    },
                ],
            },
        ],
    },
    {
        type: "split",
        mb: 1,
        columns: [
            {
                title: "Data Oferta",
                md: 12,
                fields: [
                    {
                        label: "Início",
                        value: offerData?.dataOferta?.inicio,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Encerramento máximo",
                        value: offerData?.dataOferta?.encerramentoMaximo,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Encerramento efetivo",
                        value: offerData?.dataOferta?.encerramentoEfetivo,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                ],
            },
        ],
    },
    {
        type: "split",
        mb: 2,
        columns: [
            {
                title: "Bookbuilding",
                md: 12,
                fields: [
                    {
                        label: "Tem",
                        value: offerData?.bookbuilding?.tem,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Data",
                        value: offerData?.bookbuilding?.data,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Remuneração",
                        value: offerData?.bookbuilding?.remuneracao,
                        xs: 6,
                        sm: 6,
                        md: 3,
                    },
                ],
            },
        ],
    },
    {
        type: "matrix",
        title: "Publico Alvo e Datas Lockup",
        mb: 0.5,
        columns: offerData?.publicoAlvoDatasLockup?.columns ?? [
            "IG",
            "IP",
            "IQ",
        ],
        rows: getLockupRows(offerData),
        sideGroups: [
            {
                title: "Publico alvo investidor geral",
                fields: [
                    {
                        label: "Inicial",
                        value: offerData?.publicoAlvoInvestidorGeral?.inicial,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Final",
                        value: offerData?.publicoAlvoInvestidorGeral?.final,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                ],
            },
            {
                title: "Publico alvo investidor qualificado",
                fields: [
                    {
                        label: "Inicial",
                        value: offerData?.publicoAlvoInvestidorQualificado
                            ?.inicial,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Final",
                        value: offerData?.publicoAlvoInvestidorQualificado
                            ?.final,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                ],
            },
            {
                title: "Publico alvo investidor profissional",
                fields: [
                    {
                        label: "Inicial",
                        value: offerData?.publicoAlvoInvestidorProfissional
                            ?.inicial,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                    {
                        label: "Final",
                        value: offerData?.publicoAlvoInvestidorProfissional
                            ?.final,
                        xs: 6,
                        sm: 6,
                        md: 2,
                    },
                ],
            },
        ],
    },
    {
        type: "cards",
        title: "Coordenadores",
        titleSx: {
            mb: 0.5,
        },
        cards: offerData?.coordenadores ?? [],
    },
]

export const getEmissionDetailsModalConfig = ({
    characterData,
    offerData,
}) => ({
    guarantees: {
        title: "Garantias",
        sections: [
            {
                title: "Garantias Reais",
                fields: [
                    {
                        label: `ALIENAÇÃO FIDUCIÁRIA: ${characterData?.GarantiasReais?.AlienacaoFiduciaria?.Valor ?? ""}`,
                        subfields: [
                            {
                                label: "",
                                value: characterData?.GarantiasReais?.AlienacaoFiduciaria?.Bens?.join(", "),
                            },
                        ],
                    },
                    {
                        label: `CESSÃO FIDUCIÁRIA: ${characterData?.GarantiasReais?.CessaoFiduciaria?.Quantidade ?? ""}`,
                        value: characterData?.GarantiasReais?.CessaoFiduciaria?.Descricao,
                    },

                    {
                        label: "FIANÇA BANCÁRIA",
                        value: characterData?.GarantiasReais?.FiancaBancaria,
                    },
                    {
                        label: "HIPOTECA",
                        subfields: [
                            {
                                label: characterData?.GarantiasReais?.Hipoteca?.Instituicao,
                                value: characterData?.GarantiasReais?.Hipoteca?.CNPJ,
                            },
                        ],
                    },
                    {
                        label: "PENHOR",
                        value: characterData?.GarantiasReais?.Penhor,
                    },
                ],
            },
            {
                title: "Garantias Fidejussórias",
                fields: [
                    {
                        label: "AVAL",
                        value: characterData?.GarantiasFidejussorias?.Aval,
                    },
                    {
                        label: "FIANÇA",
                        value: characterData?.GarantiasFidejussorias?.Fianca,
                    },
                ],
            },
            {
                title: "Mitigador de risco de crédito",
                fields: [
                    {
                        label: "FUNDO OBRA",
                        value: characterData?.MitigadoresRiscoCredito?.FundoObra,
                    },
                    {
                        label: "FUNDO RESERVA",
                        value: characterData?.MitigadoresRiscoCredito?.FundoReserva,
                    },
                    {
                        label: "FUNDO LIQUIDEZ",
                        value: characterData?.MitigadoresRiscoCredito?.FundoLiquidez,
                    },
                    {
                        label: "SOBREGARANTIAS",
                        value: characterData?.MitigadoresRiscoCredito?.SobreGarantias,
                    },
                    {
                        label: "SEGURO",
                        value: characterData?.MitigadoresRiscoCredito?.Seguro,
                    },
                    {
                        label: "COTAS INFERIORES",
                        value: characterData?.MitigadoresRiscoCredito?.CotasInferiores?.join(", "),
                    },
                ],
            },
            {
                title: "LTV",
                fields: [
                    {
                        label: "DATA REFERÊNCIA",
                        value: characterData?.LTV?.DataReferencia,
                    },
                    {
                        label: "VALOR",
                        value: characterData?.LTV?.Valor,
                    },
                ],
            },
        ],
    },

    offer_type: {
        title: "Oferta Pública de Distribuição",
        sections: getOfertaModalSections(offerData),
    },

    relevant_fact: {
        title: "Fato Relevante",
        sections: [
            {
                fields: [
                    {
                        label: "DATA REFERÊNCIA",
                        value: characterData?.DataReferenciaFatoRelevante,
                    },
                    {
                        label: "FATO",
                        value: characterData?.FatoRelevante,
                    },
                ],
            },
        ],
    },
})